<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <path fill="currentColor" d="m14.5 7.3-.72.7L8.5 2.89V14h-1V2.89L2.22 8l-.72-.7L8 1l6.5 6.3Z"/>
</svg>